module.exports = __webpack_public_path__ + "static/tlo_wenecja640px-717aca91e5c6325bdd334c652498971e.png";